/** https://m3.material.io/foundations/layout/applying-layout/window-size-classes */
export const M3Breakpoints = {
    Compact: '(max-width: 600px)',
    Medium: '(min-width: 600px) and (max-width: 839px)',
    Expanded: '(min-width: 840px) and (max-width: 1199px)',
    Large: '(min-width: 1200px) and (max-width: 1599px)',
    XLarge: '(min-width: 1600px)',
};